"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=writingMode.js.map